<template>
  <div>
    <v-alert type="error" prominent>
      404 Page Not Found <br />
      指定されたページは存在しません
    </v-alert>

    <div class="d-flex justify-end">
      <v-btn to="/attendance/list" color="error" variant="outlined">トップページへ</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "PageNotFound",
});
</script>
